import ActionTypes        from '../../ActionTypes';
import recipientService   from '../../services/RecipientService';
import { getSession }     from '../../services/SessionService';
import { Recipient }      from '../../types';
import { RecipientError } from '../../reduxTypes';
import { Action }         from 'redux';

export interface RecipientSuccessAction extends Action {
    recipient: Recipient;
    conversationId: number;
}

export interface RecipientErrorAction extends Action {
    error: RecipientError;
}

function loadingRecipient() {
    return {
        type: ActionTypes.RECIPIENT_LOADING
    };
}

function loadRecipientSuccess(recipient: Recipient, conversationId: number): RecipientSuccessAction {
    return {
        type: ActionTypes.RECIPIENT_LOADED,
        recipient,
        conversationId
    };
}

function loadRecipientError(error: TypeError): RecipientErrorAction {
    return {
        type: ActionTypes.RECIPIENT_LOAD_ERROR,
        error
    };
}

export function loadRecipient(conversationId: number, shouldShowLoading: boolean = true) {
    return async function loadRecipientAction(dispatch) {
        shouldShowLoading && dispatch(loadingRecipient());

        try {
            const session = await getSession();
            const { details: { conversation: { recipient }}} = await recipientService(session, conversationId);

            dispatch(loadRecipientSuccess(recipient, conversationId));
        } catch (error) {
            dispatch(loadRecipientError(error));
        }
    };
}



// WEBPACK FOOTER //
// ./src/sections/Recipient/RecipientActions.ts